// 请不要改动这个文件，如果需要在Vue.mixin上面添加methods的方法，请团队沟通

import yhcKeepAlive from '@/framework/yhcUtils/yhcKeepAlive';
import yhcRouter from '@/framework/yhcUtils/yhcRouter';

import { isArray } from 'lodash';

import 'spotlight.js';

const spotlightOptions = {
  index: 1,
  control: ['page', 'theme', 'fullscreen', 'autofit', 'zoom-in', 'zoom-out', 'close', 'prev', 'next'],
  animation: ['slide'],
  fit: 'contain',
};

class SpotlightModel {
  constructor(options = {}) {
    this.reset(options);
  }
  reset(options = {}) {
    // this.title = options.title || ''
    // this.description = options.description || ''
    this.src = options.src || '';
    // this.button = options.button || ''
    // this.onclick = options.onclick || Spotlight.download
  }
}

let setMixinMethods = {};

setMixinMethods.install = function (Vue, options) {
  Vue.mixin({
    methods: {
      // 这里的数据不要动 - start
      yhcSetLang(type = 'zh') {
        // type = zh / en / jap
        this.$i18n.locale = type;
      },

      yhcViewImage(list, index = 0, withPort = false) {
        // 这个插件的index是从1开始的
        spotlightOptions.index = index + 1;

        if (!isArray(list)) {
          list = [list];
        }

        let arr = [];

        list.map((url) => {
          let src = ``;
          if (withPort) {
            src = this.yhcPort + url;
          } else {
            src = url;
          }

          arr.push(
            new SpotlightModel({
              src: src,
            })
          );
        });

        Spotlight.show(arr, spotlightOptions);
      },

      ...yhcKeepAlive.methods,
      ...yhcRouter.methods,
      // 这里的数据不要动 - end
    },
  });
};
export default setMixinMethods;
